<card-wrapper class="panel">
  <div class="panel__container">
    <div class="panel__info">
      @if (depositBonusExpirationDate()
        && depositBonusExpirationDate().length > 0
        && account().credit > 0
        && !hasDatePassed()
      ) {
        @switch (bonusTimeLeft()) {
          @case ('imminent') {
            <span
              class="panel__expiration panel__expiration--red"
              translate="deposit-bonus.active-until.imminent"
              [translateParams]="{ date: depositBonusExpirationDate() | date: 'HH:mm' }">
              </span>
          }
          @case ('short') {
            <span
              class="panel__expiration panel__expiration--red"
              translate="deposit-bonus.active-until.short">
              </span>
          }
          @case ('medium') {
            <span
              class="panel__expiration panel__expiration--red"
              translate="deposit-bonus.active-until.medium"
              [translateParams]="{ days: daysLeft() }">
              </span>
          }
          @case ('long') {
            <span
              class="panel__expiration panel__expiration--orange"
              translate="deposit-bonus.active-until.medium"
              [translateParams]="{ days: daysLeft() }">
              </span>
          }
          @default {
            <span
              class="panel__expiration"
              translate="deposit-bonus.active-until.default"
              [translateParams]="{ date: depositBonusExpirationDate() | date: 'MMMM dd, HH:mm' }">
              </span>
          }
        }
      }

      @if (account()) {
        <div class="panel__value">
          <span>{{ account().credit | money | currency: (account().currency | fixRateCurrencyConverter) }}</span>
          <img class="panel__icon" src="./assets/img/deposit-bonus/bonus.svg" alt="" />
        </div>
      }
    </div>

    <btn [blueBorder]="true" [wide]="true" (click)="openDepositBonusTerms()" buttonText="deposit-bonus.panel.learn-more"></btn>
  </div>
</card-wrapper>
